import { component } from 'picoapp'
import Splide from '@splidejs/splide'

export default component((node) => {
  const sliderElement = node.querySelector('.splide')
  if (!sliderElement) return

  new Splide(sliderElement, {
    drag: true,
    gap: 8,
    pagination: false,
    arrows: true,
    perPage: 3,
    perMove: 1,
    breakpoints: {
      768: {
        perPage: 2,
      },
    },
  }).mount()

  // add click event listener to the slider slides
  const sliderSlideLinks = node.querySelectorAll('.splide__slide a:not(.tw-btn-primary-atc)')
  sliderSlideLinks.forEach((slide) => {
    slide.addEventListener('click', (e) => {
      e.preventDefault()
      const slideProductHandle = slide.closest('.plan').getAttribute('data-product-handle')
      if (window?.gtag) {
        gtag('event', `Curated Carousel - Product Clicked`, {
          event_detail: `${slideProductHandle}`,
        })
      }

      // send intelligems event
      window.MicroBus.emit('igEvents:push', {
        event: 'Curated Carousel - Product Clicked',
        properties: { product: slideProductHandle },
      })

      window.location.href = slide.getAttribute('href')
    })
  })

  const atcButtons = node.querySelectorAll('.splide__slide a.tw-btn-primary-atc[data-is-quick]')
  atcButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const buttonProductHandle = button.closest('[data-product-handle]').getAttribute('data-product-handle')
      const buttonType = button.getAttribute('data-is-quick') === 'true' ? 'Quick Add' : 'Shop Now'
      if (window?.gtag) {
        gtag('event', `Curated Carousel - ${buttonType} Clicked`, {
          event_detail: `${buttonProductHandle}`,
        })
      }

      // send intelligems event
      window.MicroBus.emit('igEvents:push', {
        event: `Curated Carousel - ${buttonType} Clicked`,
        properties: { plan: buttonProductHandle },
      })
    })
  })
})
